import { mutatorAction } from 'satcheljs';
import {
    accountSourceDataTypeChecker,
    AdditionalAccountInfo,
} from '../store/schema/AccountSourceList';
import { default as getAccountBySourceId } from '../selectors/getAccountBySourceId';

export default mutatorAction(
    'SET_GROUP_ACCOUNTS',
    function (sourceId: string, groupSources: AdditionalAccountInfo): void {
        const hostingAccount = getAccountBySourceId(sourceId);
        if (!hostingAccount || !accountSourceDataTypeChecker.isM365UserMailbox(hostingAccount)) {
            throw new Error(
                'We are attempting to set Group Account Info to a Non-M365UserMailboxAccountSource'
            );
        }

        hostingAccount.groupSources = groupSources;
    }
);
